import { render, staticRenderFns } from "./RequestMoreInfo.vue?vue&type=template&id=21631c89"
import script from "./RequestMoreInfo.ts?vue&type=script&lang=ts&external"
export * from "./RequestMoreInfo.ts?vue&type=script&lang=ts&external"
import style0 from "./RequestMoreInfo.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports